import React from "react";

const DEFAULT_BANNER = '/defaults/default-banner.svg';
const handleImgError = (e) => { e.target.onerror = null; e.target.src = DEFAULT_BANNER; };

function AffiliateBanner({ sliderGuide = [] }) {
  return (
    <div className="et-l et-l--body">
      <div className="et_builder_inner_content et_pb_gutters3">
        <div className="et_pb_section et_pb_section_0_tb_body et_section_regular">
          <div className="et_pb_row et_pb_row_0_tb_body">
            <div className="et_pb_column et_pb_column_4_4 et_pb_column_0_tb_body et_pb_css_mix_blend_mode_passthrough et-last-child">
              <div className="et_pb_module et_pb_text et_pb_text_0_tb_body et_pb_text_align_center et_pb_bg_layout_light">
                <div className="et_pb_text_inner">
                  <h1>Affiliate Guide</h1>
                  <p>Learn how to become a successful affiliate partner</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {sliderGuide.length > 0 && (
          <div className="et_pb_section et_pb_section_1_tb_body et_section_regular">
            <div className="et_pb_row et_pb_row_1_tb_body">
              <div className="et_pb_column et_pb_column_4_4 et_pb_column_1_tb_body et_pb_css_mix_blend_mode_passthrough et-last-child">
                {sliderGuide.map((item, i) => {
                  const imgPath = item.thumbnail || item.thubmnail;
                  return (
                    <div key={i} className="et_pb_module et_pb_blurb et_pb_text_align_left et_pb_bg_layout_light" style={{ marginBottom: '30px' }}>
                      <div className="et_pb_blurb_content" style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', alignItems: 'center' }}>
                        {imgPath && (
                          <div className="et_pb_main_blurb_image affiliate-guide-img" style={{ flex: '0 0 300px' }}>
                            <img decoding="async" src={`${process.env.REACT_APP_API_URL}/storage/${imgPath}`} alt={item.name || ''} style={{ width: '100%', borderRadius: '10px' }} onError={handleImgError} />
                          </div>
                        )}                        {!imgPath && (
                          <div className="et_pb_main_blurb_image affiliate-guide-img" style={{ flex: '0 0 300px' }}>
                            <img decoding="async" src={DEFAULT_BANNER} alt={item.name || 'Guide'} style={{ width: '100%', borderRadius: '10px' }} />
                          </div>
                        )}                        <div className="et_pb_blurb_container affiliate-guide-content" style={{ flex: '1', minWidth: 0 }}>
                          {item.name && <h2 className="et_pb_module_header"><span className="yellow-color">{item.name}</span></h2>}
                          {item.link && <div dangerouslySetInnerHTML={{ __html: item.link }} />}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AffiliateBanner;
